// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3pjAy","content":"styles_content__1j0E7"};